import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { AutorisationBnbaccessComponent } from './autorisation-bnbaccess.component';
import { AutorisationBnbaccessDetailComponent } from './autorisation-bnbaccess-detail.component';
import { AutorisationBnbaccessPopupComponent } from './autorisation-bnbaccess-dialog.component';
import { AutorisationBnbaccessDeletePopupComponent } from './autorisation-bnbaccess-delete-dialog.component';

import { Principal } from '../../shared';


export const autorisationRoute: Routes = [
  {
    path: 'autorisation-bnbaccess',
    component: AutorisationBnbaccessComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'bnbaccessBoApp.autorisation.home.title'
    }
  }, {
    path: 'autorisation-bnbaccess/:id',
    component: AutorisationBnbaccessDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'bnbaccessBoApp.autorisation.home.title'
    }
  }
];

export const autorisationPopupRoute: Routes = [
  {
    path: 'autorisation-bnbaccess-new',
    component: AutorisationBnbaccessPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'bnbaccessBoApp.autorisation.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'autorisation-bnbaccess/:id/edit',
    component: AutorisationBnbaccessPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'bnbaccessBoApp.autorisation.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'autorisation-bnbaccess/:id/delete',
    component: AutorisationBnbaccessDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'bnbaccessBoApp.autorisation.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess.route.ts